module.exports = __webpack_public_path__ + "img/icon-arrow-prev.cd37f250.svg";